module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jJwEK"))).then(() => parcelRequire('ikE14'));